import React from 'react/addons'
import Tbl from './Tbl'
import updateLen from 'lib/updateLen'
import Range from 'components/Range'
import Radio from 'components/Radio'

let calcLens = (data) => {
	let colsData = []
	let lens = {}
	Object.keys(data).forEach(id => {
		let row = data[id]
		row.forEach((cell, i) => {
			colsData[i] = colsData[i] || []
			colsData[i].push(cell)
		})
	})
	colsData.forEach((col, i) => {
		let len = col.reduce((len, cell) => {
			let n = parseFloat(cell)
			if(isNaN(n) || len === null) {
				len = null
			} else {
				len = updateLen(n, len)
			}

			return len
		}, [0, 0])

		if(len) {
			lens[i] = len
		}
	})

	return lens
}

let getRealScrollX = () => Math.max(0, Math.min(window.scrollX, document.documentElement.scrollWidth - window.innerWidth))

const SimpleTableApp = React.createClass({

	getInitialState() {
		const { filters } = this.props;
		return {
			fixed: false,
			bottom: false,
			lens: {},
			filter: filters.reduce((memo, {type, values, i}) => {
				// console.log(type, values, i);
				return {
					...memo,
					[i]: type === 'enum' ? [] : [Math.min.apply(null, values), Math.max.apply(null, values)]
				}
			}, {}),
			cart: this.props.flux.getStore('cartStore').getState()
		};
	},

	componentWillMount() {
		this.setState({
			lens: calcLens(this.props.data)
		})
		this.props.flux.getStore('cartStore').listen(this.handleCartChange)
		document.addEventListener('scroll', this.handleScroll)
	},

	componentWillUnmount() {
		this.props.flux.getStore('cartStore').unlisten(this.handleCartChange)
		document.removeEventListener('scroll', this.handleScroll)
	},

	handleCartChange() {
		this.setState({cart: this.props.flux.getStore('cartStore').getState()})
	},

	handleScroll() {
		const el = this.refs.el.getDOMNode();

		if(el) {
			const elRect = el.getBoundingClientRect();
			if(elRect.bottom - 300 < 0 && elRect.top < 0) {
				this.setState({fixed: false, bottom: true});
			} else if(elRect.top < 0) {
				let header = this.refs.header.getDOMNode()
				this.setState({fixed: true, bottom: false});
				header.style.marginLeft = -getRealScrollX() + 'px';
				header.style.width = elRect.width + 'px';
			} else if(elRect.top > 0) {
				this.setState({fixed: false, bottom: false});
			}
		} else {
			this.setState({fixed: false, bottom: false});
		}
	},

	handleFilterChange(i, value) {
		this.setState({
			filter: {
				...this.state.filter,
				[i]: value
			}
		});
	},

	render() {
		const { bottom, fixed, filter } = this.state;
		const { filters, cols } = this.props;
		const headerStyle = bottom ? styles.bottomFixedHeader : fixed ? styles.fixedHeader : styles.header;
		const data = filterData(this.props.data, filter, filters);
		const isEmpty = Object.keys(data).length === 0;

		return (
			<div className="simple-tbl">
				{filters.length > 0 &&
					<div className="complex-tbl__filt">
						{filters.map(({type, values, i}) =>
							<div key={i} className={`complex-tbl__filt-i complex-tbl__filt-i--${type}`}>
								<label>
									{cols[i]}
									{type === 'number' &&
										<strong> {filter[i].join('-')}</strong>
									}
								</label>
								<div style={{height: 35, paddingTop: type === 'number' ? 17 : 0}}>
									{type === 'number' &&
										<Range
											min={Math.min.apply(null, values)}
											max={Math.max.apply(null, values)}
											value={filter[i]}
											onChange={value => this.handleFilterChange(i, value)}
											/>
									}
									{type === 'enum' &&
										<Radio
											options={values}
											value={filter[i]}
											onChange={value => this.handleFilterChange(i, value)}
											/>
									}
								</div>
							</div>
						)}
					</div>
				}

				{!isEmpty &&
					<div ref="el" style={{position: 'relative'}}>
						<Tbl
							data={data}
							cols={cols}
							lens={this.state.lens}
							cart={this.state.cart}
							productId={this.props.productId}
							onAddToCart={this.props.flux.getActions('cartActions').addItem}
							onRemoveFromCart={this.props.flux.getActions('cartActions').removeItem}
							/>
						<div ref="header" style={headerStyle}>
							<Tbl
								data={data}
								cols={cols}
								lens={this.state.lens}
								cart={this.state.cart}
								productId={this.props.productId}
								onAddToCart={this.props.flux.getActions('cartActions').addItem}
								onRemoveFromCart={this.props.flux.getActions('cartActions').removeItem}
								/>
						</div>
					</div>
				}
				{isEmpty &&
					<div className="complex-tbl__empty">
						Нет позиций с заданными параметрами. Попробуйте установить другие значения для фильтра
					</div>
				}
			</div>
		)
	}

})

export default SimpleTableApp

function filterData(data, filterValues, filterConfig) {
	if(filterConfig.length === 0) {
		return data;
	} else {
		const filters = filterConfig.reduce((memo, {values, i, type}) => {
			return {
				...memo,
				[i]: {values, type, i, value: filterValues[i]}
			}
		}, {});
		console.log(filters);
		return Object.keys(data).filter(key => {
			const row = data[key];
			return row.reduce((memo, cell, i) => {
				if(cellIsMatchFilter(cell, filters[i])) {
					return [...memo, cell];
				} else {
					return memo;
				}
			}, []).length === row.length;
		}).reduce((memo, key) => ({...memo, [key]: data[key]}), {});
	}

}

function cellIsMatchFilter(cell, filter) {
	if(filter) {
		if(filter.type === 'enum' && filter.value.length > 0) {
			return filter.value.filter(val => val == cell).length > 0;
			// return filter.value.indexOf(cell) !== -1 || filter.value.indexOf(`${cell}`) !== -1;
		}

		if(filter.type === 'number') {
			return filter.value[0] <= cell && filter.value[1] >= cell;
		}
	}

	return true;
}

let styles = {
	header: {
		position: 'absolute',
		zIndex: 1,
		height: 44,
		top: 0,
		left: 0,
		marginLeft: 0,
		overflow: 'hidden'
	},
	fixedHeader: {
		position: 'fixed',
		zIndex: 1,
		height: 44,
		top: 0,
		overflow: 'hidden'
	},
	bottomFixedHeader: {
		position: 'absolute',
		zIndex: 1,
		height: 44,
		bottom: 256,
		marginLeft: 0,
		overflow: 'hidden'
	}
}


/** WEBPACK FOOTER **
 ** ./src/scripts/components/SimpleTableApp/SimpleTableApp.js
 **/